<template>
  <div class="upload_img">
    <div
      v-if='imageUrl'
      class="img"
    >
      <p :style="'background-image: url('+ imageUrl +')'"></p>
      <i></i>
      <b></b>
    </div>
    <div
      v-else
      class="add"
    >
      <div>
        <span></span>
      </div>
      <p>{{message}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["message", "imageUrl"],
  data() {
    return {
      // imageUrl:''
    };
  }
};
</script>

<style lang='less'>
.upload_img {
  width: 160px;
  height: 129px;
  border: 1px dashed #fcc800;
  border-radius: 5px;
  background-color: #fff9e5;
  padding-top: 9px;
  cursor: pointer;
  .img {
    text-align: center;
    height: 120px;
    position: relative;
    p {
      width: 120px;
			height: 120px;
			display: inline-block;
			background-repeat: no-repeat;
			background-position: 50% 50%;
			background-size: 100%;
    }
    i {
      position: absolute;
      right: -1px;
      bottom: -10px;
      width: 32px;
      height: 33px;
      background: url("~@img/upload_img.png") 0 0 no-repeat;
      z-index: 2;
    }
    b {
      position: absolute;
      left: 0;
      top: -9px;
      width: 160px;
      height: 138px;
      background-color: #fff;
      opacity: 0;
    }
    b:hover {
      opacity: 0.5;
    }
  }
  .add {
    text-align: center;
    position: relative;
    & > div {
      padding-top: 22px;
      height: 30px;
      margin-bottom: 17px;
    }
    span {
      width: 29px;
      height: 30px;
      display: inline-block;
      background: url("~@img/upload_img.png") 0 -37px no-repeat;
    }
    & > p {
      font-size: 14px;
      color: #999;
      line-height: 17px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// upload_img.vue?21e9a7ed